"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataProcessing = void 0;
var lodash_1 = require("lodash");
var input_output_helper_const_1 = require("@const/input-output-helper.const");
var translation_1 = __importDefault(require("@services/translation"));
var cash_dom_1 = __importDefault(require("cash-dom"));
var DataProcessing = /** @class */ (function () {
    function DataProcessing() {
    }
    // private readonly _ExtraValues: {
    //   [type: string]: (object: Object) => string | undefined;
    // } = {
    //   dateOfBirthDD: (obj) =>
    //     this.extractFromStringValue('dateOfBirth', obj, /-(\d\d)$/),
    //   dateOfBirthMM: (obj) =>
    //     this.extractFromStringValue('dateOfBirth', obj, /-(\d\d)-/),
    //   dateOfBirthYYYY: (obj) =>
    //     this.extractFromStringValue('dateOfBirth', obj, /^(\d{4})-/),
    // }; //TODO change keys
    // private readonly _NameMapping = {
    //   accountHolder: "bankAccount.accountHolder",
    //   bankName: "bankAccount.bankName",
    //   bic: "bankAccount.bic",
    //   iban: "bankAccount.iban",
    // }
    DataProcessing.prototype.fillDataGet = function (parent, object) {
        (0, cash_dom_1.default)(parent)
            .find('[data-get]')
            .each(function (i, element) {
            var key = (0, cash_dom_1.default)(element).attr('data-get');
            var value = translation_1.default.t((0, lodash_1.get)(object, key));
            // if (!(typeof value === "string")) {
            //   let func = this._ExtraValues[key];
            //   if (func) value = func(object);
            // }
            if (value !== null) {
                var currentHtml = (0, cash_dom_1.default)(element).html();
                var regex = new RegExp("{{".concat(key, "}}"), 'gi');
                if (regex.test(currentHtml)) {
                    (0, cash_dom_1.default)(element).html(currentHtml.replace(regex, value));
                }
                else if ((0, cash_dom_1.default)(element).is("input[type='text']")) {
                    (0, cash_dom_1.default)(element).val(value);
                }
                else if ((0, cash_dom_1.default)(element).is("input[type='radio']")) {
                    if ((0, cash_dom_1.default)(element).val() == value) {
                        (0, cash_dom_1.default)(element).prop('checked', true);
                        (0, input_output_helper_const_1._UpdateRenderOfRadioField)((0, cash_dom_1.default)(element), true);
                    }
                }
                else if ((0, cash_dom_1.default)(element).is('img')) {
                    (0, cash_dom_1.default)(element).attr('src', value);
                }
                else {
                    (0, cash_dom_1.default)(element).html(value); // for all others?
                }
            }
            else {
                console.log("Property '" +
                    key +
                    "' does not exist or is null. Available properties are:" +
                    (0, lodash_1.keys)(object)
                        .filter(function (availableKey) { return typeof (0, lodash_1.get)(object, availableKey) !== null; })
                        .join(', ')
                // + ', ' +
                // Object.keys(this._ExtraValues).join(', ')
                );
            }
        });
    };
    DataProcessing.prototype.mapDataAction = function (parent, actionMapping) {
        //remove old event listeners
        (0, cash_dom_1.default)(parent).find('[data-action="submit"]').off();
        (0, cash_dom_1.default)(parent)
            .find('[data-action]')
            .on('click', function (event) {
            var action = actionMapping[(0, cash_dom_1.default)(event.currentTarget).attr('data-action')];
            if (action) {
                action(event);
            }
            else {
                console.error("The action ".concat((0, cash_dom_1.default)(event.currentTarget).attr('data-action'), " does not have an implementation"));
            }
        });
    };
    DataProcessing.prototype.extractFromStringValue = function (key, object, regex) {
        var value = object[key];
        if (typeof value === 'string') {
            var matches = value.match(regex);
            return matches[1] || matches[0];
        }
        else {
            console.log("Property '" + key + "' does not exist, or isn't a string.");
            return undefined;
        }
    };
    return DataProcessing;
}());
exports.DataProcessing = DataProcessing;
